<div class="table-header-wrapper">
  <ion-row class="table-header">
    <span>{{ header }}</span>
  </ion-row>

  <ion-row class="table-subheader">
    <span>{{ subHeader }}</span>
  </ion-row>
</div>
